import { Component } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { MatDialogRef } from '@angular/material/dialog';
import { AppContext } from '../../models/appContext';
import { userPreference } from '../../common/tabs.constant';

@Component({
  selector: 'app-user-preferences',
  templateUrl: './user-preferences.component.html',
  styleUrl: './user-preferences.component.scss',
})

export class UserPreferenceComponent {

  constructor( 
    private readonly commonService: CommonService, 
    private readonly dialogRef: MatDialogRef<UserPreferenceComponent>, 
  ) {
    this.userGPID = localStorage.getItem("userGPID");
    this.systemId = localStorage.getItem('SelectedSystemId');
    this.selectedRoutingDisplayOption = "";
  }

  title = 'material-expansion-example';
  dateFormatText: string | null = "";
  searchFieldOptions: any;
  selectedRoutingDisplayOption: string | null;
  prefLoading: boolean = true;
  inboxFields: any = {};
  timezoneVal: string | null = "";
  timezones: any;
  fullname: boolean = false;
  gpid: boolean = false;
  isSendToWorkflowEnabled: boolean = false;
  notToWorkflow: boolean = false;
  isEmailNotifyEnabled: boolean = false;
  noSendEmail: boolean = false;
  sendEmail: boolean = false;
  toWorkflow: boolean = false;
  isInboxFieldEnabled: boolean = false;
  inboxFieldsYes: boolean = false;
  inboxFieldsNo: boolean = false;
  defaultSortingOrderAsc: boolean = false;
  defaultSortingOrderDesc: boolean = false;
  isSortingOptionEnabled: boolean = false;
  isSortingPropertyEnabled: boolean = false;
  isWorkItemCountEnabled: boolean = false;
  workItemCount: number = 0;
  getNextWorkItem: string | null = "";
  isGetNextWorkItemEnabled: boolean = false;
  sortingProperty: string | null = "";
  GetNextWorkItemFields: any = {};
  isUserPreferencesLoading: boolean = false;
  userPrefData: any[] = [];
  isSystemAdmin: boolean = true;
  disableOrHideBasedOnSystem: boolean = true;
  message: string | null = null;
  isSuccess: boolean = true;
  userGPID: string | null;
  systemId: string | null;
  public readonly optionsEmitter = userPreference;

  ngOnInit(): void {
    this.getUserPreference();
  }

  getUserPreference(): void {
    this.prefLoading = true;

    this.commonService.getUserPerferences().subscribe({
      next: (data: any[]) => {
        this.userPrefData = data;
        this.selectedRoutingDisplayOption = localStorage.getItem('setUserPerferenceRoutingButton') ?? 'button';

        data.forEach((item: any) => {
          this.applyUserPreference(item);
        });

        this.prefLoading = false;
      },
      error: () => {
        this.prefLoading = false;
      }
    });
  }

  private applyUserPreference(item: any): void {
    if (item?.dateFormatOptions?.length > 0) {
      this.dateFormatText = item.preferenceValue;
      this.searchFieldOptions = item.dateFormatOptions;
    }

    if (item.preferenceId === 0) {
      this.inboxFields = item.inboxFields;
    }

    const handlers: Record<string, () => void> = {
      [this.optionsEmitter.DateFormatDisplay]: () => {
        this.dateFormatText = item.preferenceValue;
      },
      [this.optionsEmitter.Timezone]: () => {
        this.timezoneVal = item.preferenceValue;
        this.timezones = item.timezone;
      },
      [this.optionsEmitter.userNameDisplay]: () => {
        const isTrue = item.preferenceValue === 'true';
        this.gpid = isTrue;
        this.fullname = !isTrue;
      },
      [this.optionsEmitter.RoutingInWorkflow]: () => {
        this.selectedRoutingDisplayOption = item.preferenceValue === 'true' ? 'button' : 'select';
        localStorage.setItem('setUserPerferenceRoutingButton', this.selectedRoutingDisplayOption);
      },
      [this.optionsEmitter.SendToWorkflow]: () => {
        this.isSendToWorkflowEnabled = item.canOverride;
        this.toWorkflow = item.preferenceValue === 'true';
        this.notToWorkflow = !this.toWorkflow;
      },
      [this.optionsEmitter.emailNotification]: () => {
        this.isEmailNotifyEnabled = item.canOverride;
        this.sendEmail = item.preferenceValue === 'true';
        this.noSendEmail = !this.sendEmail;
      },
      [this.optionsEmitter.DisplayInboxFields]: () => {
        this.isInboxFieldEnabled = item.canOverride;
        this.inboxFieldsYes = item.preferenceValue === 'true';
        this.inboxFieldsNo = !this.inboxFieldsYes;
      },
      [this.optionsEmitter.SortingOption]: () => {
        this.isSortingOptionEnabled = item.canOverride;

        if (item.preferenceValue === 'Ascending') {
          this.defaultSortingOrderAsc = true;
          this.defaultSortingOrderDesc = false;
          localStorage.setItem('setSortingOption', 'asc');
          return;
        }

        if (item.preferenceValue === 'Descending') {
          this.defaultSortingOrderDesc = true;
          this.defaultSortingOrderAsc = false;
          localStorage.setItem('setSortingOption', 'desc');
        }
      },
      [this.optionsEmitter.SortingProperty]: () => {
        this.isSortingPropertyEnabled = item.canOverride;
        this.sortingProperty = item.preferenceValue;
      },
      [this.optionsEmitter.WorkItemCount]: () => {
        this.isWorkItemCountEnabled = item.canOverride;
        this.workItemCount = Number(item.preferenceValue);
      },
      [this.optionsEmitter.GetNextWorkItem]: () => {
        this.getNextWorkItem = item.preferenceValue;
        this.isGetNextWorkItemEnabled = item.canOverride;
        this.GetNextWorkItemFields = item.getNextWorkItemFields;
      }
    };

    const handler = handlers[item.preferenceTitle];
    if (handler) {
      handler();
    }
  }

  cancel(): void {
    this.dialogRef.close('cancel');
  }

  saveUserPref(): void {
    const postObj: any[] = [];
    this.userPrefData.forEach((item: any, index: number) => {
      postObj.push({ ...item });
      const prefVal = item.preferenceValue;
      switch (this.userPrefData[index].preferenceTitle) {
        case this.optionsEmitter.DateFormatDisplay:
          postObj[index].preferenceValue = this.dateFormatText;
          break;
        case this.optionsEmitter.Timezone:
          postObj[index].preferenceValue = this.timezoneVal;
          break;
        case this.optionsEmitter.userNameDisplay:
          postObj[index].preferenceValue = this.fullname ? "true" : "false";
          break;
        case this.optionsEmitter.RoutingInWorkflow:
          postObj[index].preferenceValue =
            this.selectedRoutingDisplayOption == "button"
              ? "true"
              : "false";
          break;
        case this.optionsEmitter.SendToWorkflow:
          postObj[index].preferenceValue = this.toWorkflow
            ? "true"
            : "false";
          break;
        case this.optionsEmitter.emailNotification:
          postObj[index].preferenceValue = this.sendEmail
            ? "true"
            : "false";
          break;
        case this.optionsEmitter.DisplayInboxFields:
          postObj[index].preferenceValue = this.inboxFieldsYes
            ? "true"
            : "false";
          break;
        case this.optionsEmitter.SortingOption:
          postObj[index].preferenceValue = this.defaultSortingOrderAsc
            ? "Ascending"
            : "Descending";
          break;
        case this.optionsEmitter.SortingProperty:
          postObj[index].preferenceValue = this.sortingProperty;
          break;
        case this.optionsEmitter.WorkItemCount:
          postObj[index].preferenceValue = this.workItemCount;
          break;
        case this.optionsEmitter.GetNextWorkItem:
          postObj[index].preferenceValue = this.getNextWorkItem;
          break;
      }
      postObj[index].IsUpdated =
        prefVal == postObj[index].preferenceValue ? false : true;
    });

    this.isUserPreferencesLoading = true;

    this.commonService.saveUserPerferences(postObj).subscribe(
      (response) => {
        this.isUserPreferencesLoading = false;
        this.isSuccess = true;
        this.message = `Saved user preferences for user ${AppContext.userDetails.userName}`;
        setTimeout(() => {
          this.cancel();
        }, 1500);
      },
      (error) => {
        this.isUserPreferencesLoading = false;
        this.isSuccess = false;
        this.message = "Error code: " + error?.ErrorCode + " - Unable to save user preference for user " + AppContext.userDetails.userName;
      }
    )
  }
}